// 내보내기 확인·경고 문구의 레코드 종류 단어 선택 — 메모 레코드 단건 내보내기는 "비밀번호"가
// 아니라 "메모"로 읽혀야 한다.
//
// {{service}} 인터폴레이션(삭제·공유 팝업의 getRecordServiceKey 패턴) 대신 언어별 전용 키를
// 쓰는 이유: 영어 원문이 복수형·소유격까지 포함한 자연 문장("your saved passwords")이라
// 명사만 끼워 넣으면 수 일치가 깨진다(“your saved Memo”). 문장을 언어별로 따로 두는 편이 안전.
//
// bulkExport.js(node-forge·streamsaver·antd 의존)와 분리해 의존성 zero 로 유지 — 단위 테스트가
// 무거운 mock 없이 이 매핑만 검증할 수 있다.
export const getExportTextKeys = (isMemo) =>
  isMemo
    ? {
        confirmTitle: 'record.desc.exportMemoConfirmTitle',
        confirmQuestion: 'record.desc.exportMemoConfirmQuestion',
        skipQuestion: 'record.desc.exportMemoSkipWarningQuestion',
        skipDesc: 'record.desc.exportMemoSkipWarningDesc',
      }
    : {
        confirmTitle: 'record.desc.exportConfirmTitle',
        confirmQuestion: 'record.desc.exportConfirmQuestion',
        skipQuestion: 'record.desc.exportSkipWarningQuestion',
        skipDesc: 'record.desc.exportSkipWarningDesc',
      }

export default getExportTextKeys
